module.exports = __webpack_public_path__ + "static/media/firesafes_usb_port-ex.15ef4a5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/model-serial-number/firesafes_usb_port-ex.png
// module id = 1288
// module chunks = 0